import { useQueryClient } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import { type JobInput, jobsApi } from "@/api/jobs"
import { ApiError } from "@/api/client"
import { JobForm } from "@/components/dashboard/job-form"
import { PageHeader } from "@/components/dashboard/page-header"

export function JobNewPage() {
  const nav = useNavigate()
  const qc = useQueryClient()

  async function onSubmit(values: JobInput) {
    try {
      const res = await jobsApi.create(values)
      qc.invalidateQueries({ queryKey: ["jobs"] })
      toast.success("İlan oluşturuldu.")
      nav(`/dashboard/jobs/${res.data.id}`, { replace: true })
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : "İlan oluşturulamadı.")
      throw err
    }
  }

  return (
    <>
      <PageHeader title="Yeni ilan" description="Önce taslak olarak kaydedilir, sonra yayımlayabilirsin." />
      <div className="p-6">
        <JobForm submitLabel="Taslak olarak kaydet" onSubmit={onSubmit} onCancel={() => nav(-1)} />
      </div>
    </>
  )
}
